import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, ButtonComponent, RtButtonVariant } from '@core/user-interface-legacy';

interface CreateWithAiButtonScope {
  scope: 'description' | 'requirements';
  isAccountVerified: boolean;
}

type CreateWithAiButtonContext = 'redactor' | 'prosemirror';

@Component({
  selector: 'rt-create-with-ai-button',
  templateUrl: './create-with-ai-button.component.html',
  styleUrls: ['./create-with-ai-button.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, BadgeComponent, ButtonComponent, NgTemplateOutlet],
})
export class CreateWithAiButtonComponent {
  private readonly i18n = inject(I18nService);

  public readonly scope = input<CreateWithAiButtonScope>(undefined!);
  public readonly context = input<CreateWithAiButtonContext>('redactor');
  public readonly buttonVariant =
    input<Extract<RtButtonVariant, 'outline' | 'tertiary'>>('outline');
}
